module.exports = __webpack_public_path__ + "media/application/assets/images/company/stakeholders/arrow_down_muted-93e2255ff689adc5ba91bd55861bd1e6.svg";